// extracted by mini-css-extract-plugin
export default {"DummyText":"DummyText_DummyText__i-gHQ"};